var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 28.7047L83.2953 4.102C80.6493 1.456 77.1353 0 73.3973 0H38.6027C34.8647 0 31.3507 1.456 28.7047 4.102L4.102 28.7047C1.456 31.3507 0 34.8647 0 38.6027V73.3973C0 77.1353 1.456 80.6493 4.102 83.2953L28.7047 107.898C31.3507 110.544 34.8647 112 38.6027 112H73.3973C77.1353 112 80.6493 110.544 83.2953 107.898L107.898 83.2953C110.544 80.6493 112 77.1353 112 73.3973V38.6027C112 34.8647 110.544 31.3507 107.898 28.7047ZM57.274 69.496C55.4447 71.3253 53.0087 72.3333 50.4233 72.3333C47.838 72.3333 45.402 71.3253 43.5727 69.4913L26.7073 52.626L33.306 46.0273L50.176 62.8927C50.2927 63.0093 50.5587 63.0047 50.68 62.8927L78.9553 34.6173L85.554 41.216L57.2787 69.4913L57.274 69.496Z",
    fill: "#32BC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmMessage);
export default __webpack_public_path__ + "static/media/confirm-message.4b7ca725cb704b8bf9082a69244fc599.svg";
export { ForwardRef as ReactComponent };